import React from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const BreadcrumbView = () => {
  const navigate = useNavigate();
  return (
    <Breadcrumb separator=">">
      <Breadcrumb.Item onClick={() => navigate(`/home`)}>
        <HomeOutlined />
        &thinsp;首页
      </Breadcrumb.Item>
      <Breadcrumb.Item>新闻资讯</Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default BreadcrumbView;
